import React from 'react';

import { ReactComponent as SearchIcon } from '../../../svg/search.svg';
import { ReactComponent as ClearIcon } from '../../../svg/clear.svg';

import classes from './Search.module.scss';

const Search = props => {
    return <div className={classes.Search}>
        <div className={classes.SearchInput}>
            <input
                type="text"
                placeholder={props.placeholder}
                value={props.filter}
                onChange={event => props.setFilter(event.target.value)} />
        </div>
        <div className={classes.ClearIcon} onClick={() => props.setFilter('')}>
            {props.filter === '' ? <SearchIcon /> : <ClearIcon /> }
        </div>
    </div>
}

export default Search;